import { render, staticRenderFns } from "./CompetitionQuery.vue?vue&type=template&id=1ddf22aa&scoped=true"
import script from "./CompetitionQuery.vue?vue&type=script&lang=js"
export * from "./CompetitionQuery.vue?vue&type=script&lang=js"
import style0 from "./CompetitionQuery.vue?vue&type=style&index=0&id=1ddf22aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf22aa",
  null
  
)

export default component.exports